import { DisplayValue } from '@adaptiva/core/common';
import { ContentOverrideForUninstallationProperties, EFileType, ESourceType, MetadataSerialization } from '@adaptiva/metadata/common';
import { OverlayComponent } from '@adaptiva/widgets/overlay';
import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { BaseContentAuthoringProperties } from '../base-content-authoring-properties';

@Component({
	standalone: false,
	selector: 'ada-content-override-for-uninstallation-properties',
	templateUrl: './content-override-for-uninstallation-properties.component.html',
	styleUrls: ['../base-content-authoring-properties/base-content-authoring-properties.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentOverrideForUninstallationPropertiesComponent
	extends BaseContentAuthoringProperties<ContentOverrideForUninstallationProperties> {

	@ViewChild('UploadOverlay')
	public uploadOverlay: OverlayComponent;

	public override fileType: EFileType = EFileType.UNINSTALL;

	public propertyConstructor: MetadataSerialization.Deserializable<ContentOverrideForUninstallationProperties>
		= ContentOverrideForUninstallationProperties;

}
